import { MatDialog } from '@angular/material';
import { FcChoiceDialogComponent } from './fc-choice-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var FcChoiceDialogService = /** @class */ (function () {
    function FcChoiceDialogService(matDialog) {
        this.matDialog = matDialog;
    }
    FcChoiceDialogService.prototype.open = function (_a) {
        var title = _a.title, description = _a.description, options = _a.options;
        return this.matDialog.open(FcChoiceDialogComponent, {
            data: { title: title, description: description, options: options },
            disableClose: true
        }).afterClosed()
            .toPromise();
    };
    FcChoiceDialogService.prototype.close = function () {
        this.matDialog.closeAll();
    };
    FcChoiceDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FcChoiceDialogService_Factory() { return new FcChoiceDialogService(i0.ɵɵinject(i1.MatDialog)); }, token: FcChoiceDialogService, providedIn: "root" });
    return FcChoiceDialogService;
}());
export { FcChoiceDialogService };
